"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPTextField = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var style_1 = require("./style");
require("../../assets/style.css");
var Masks_1 = require("./Masks");
var theme_1 = require("../../globals/theme");
var PPTooltip_1 = __importDefault(require("../PPTooltip"));
var PPTextField = function (_a) {
    var help = _a.help, helpIcon = _a.helpIcon, clearIcon = _a.clearIcon, iconPosition = _a.iconPosition, clearInput = _a.clearInput, upDown = _a.upDown, addFunction = _a.addFunction, subtractFuntion = _a.subtractFuntion, label = _a.label, icon = _a.icon, disabled = _a.disabled, required = _a.required, readOnly = _a.readOnly, onChange = _a.onChange, multiline = _a.multiline, resizeHandle = _a.resizeHandle, sugestions = _a.sugestions, props = __rest(_a, ["help", "helpIcon", "clearIcon", "iconPosition", "clearInput", "upDown", "addFunction", "subtractFuntion", "label", "icon", "disabled", "required", "readOnly", "onChange", "multiline", "resizeHandle", "sugestions"]);
    var classes = (0, style_1.useStyles)();
    var sizes = help && helpIcon ? 11 : 12;
    var _b = (0, react_1.useState)(props.value || ""), maskedValue = _b[0], setMaskedValue = _b[1];
    var _c = (0, react_1.useState)(props.value || ""), inputValue = _c[0], setInputValue = _c[1];
    var _d = (0, react_1.useState)(false), focused = _d[0], setFocused = _d[1];
    var _e = (0, react_1.useState)([]), sugestionsList = _e[0], setSugestionsList = _e[1];
    var _f = (0, react_1.useState)(false), loadingSugestionsList = _f[0], setLoadingSugestionsList = _f[1];
    var increment = props.increment ? props.increment : 1;
    (0, react_1.useEffect)(function () {
        var _a;
        var mask = (0, Masks_1.generateMaskForType)((_a = props.mask) === null || _a === void 0 ? void 0 : _a.toLowerCase());
        if (!mask)
            return;
        var value = mask.resolve("".concat(maskedValue));
        setMaskedValue(value);
        setInputValue(value);
    }, []);
    var handleClear = function () {
        setMaskedValue("");
        setInputValue("");
        if (clearInput)
            clearInput();
    };
    var handleAddFunction = function () {
        if (props.decimalPlaces !== 0) {
            setMaskedValue((parseFloat(inputValue || "0") + increment).toFixed(props.decimalPlaces));
            setInputValue((parseFloat(inputValue || "0") + increment).toFixed(props.decimalPlaces));
        }
        else {
            setMaskedValue(parseInt(inputValue || "0") + increment);
            setInputValue(parseInt(inputValue || "0") + increment);
        }
        if (addFunction)
            addFunction();
    };
    var handleSubtractFuntion = function () {
        if (props.decimalPlaces !== 0) {
            setMaskedValue((parseFloat(inputValue || "0") - increment).toFixed(props.decimalPlaces));
            setInputValue((parseFloat(inputValue || "0") - increment).toFixed(props.decimalPlaces));
        }
        else {
            setMaskedValue(parseInt(inputValue || "0") - increment);
            setInputValue(parseInt(inputValue || "0") - increment);
        }
        if (subtractFuntion)
            subtractFuntion();
    };
    var getClassnameByType = function () {
        var multilineName = multiline ? "multiline" : "";
        var cls = disabled
            ? "".concat(multilineName, "_disabled")
            : required && props.error
                ? "".concat(multilineName, "_required_error")
                : required
                    ? "".concat(multilineName, "_required")
                    : readOnly
                        ? "".concat(multilineName, "_readOnly")
                        : multiline
                            ? "".concat(multilineName)
                            : "root";
        return classes[cls];
    };
    var renderIcon = function () {
        var iconProp = {};
        var iconElement = function (iconName) {
            return (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                react_1.default.createElement(core_1.ButtonGroup, { orientation: "horizontal" },
                    clearIcon && (react_1.default.createElement(core_1.IconButton, { edge: "end", onClick: handleClear }, clearIcon === true ? (react_1.default.createElement("i", { className: "ppi ppi-x" })) : (react_1.default.createElement("i", { className: "ppi ppi-".concat(clearIcon) })))),
                    react_1.default.createElement(core_1.IconButton, { edge: "end" },
                        react_1.default.createElement("i", { className: "ppi ppi-".concat(iconName || "x") })))));
        };
        switch (upDown) {
            case "vertical": {
                iconProp = {
                    endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "end" },
                        react_1.default.createElement(core_1.ButtonGroup, { orientation: "vertical", "aria-label": "vertical outlined button group", size: "small" },
                            react_1.default.createElement(core_1.IconButton, { edge: "end", onClick: handleAddFunction },
                                react_1.default.createElement("i", { className: "ppi ppi-chevron-up" })),
                            react_1.default.createElement(core_1.IconButton, { edge: "end", onClick: handleSubtractFuntion },
                                react_1.default.createElement("i", { className: "ppi ppi-chevron-down" }))))),
                };
                break;
            }
            case "horizontal": {
                iconProp = {
                    startAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                        react_1.default.createElement(core_1.IconButton, { edge: "end", onClick: handleSubtractFuntion },
                            react_1.default.createElement("i", { className: "ppi ppi-chevron-left" })))),
                    endAdornment: (react_1.default.createElement(core_1.InputAdornment, { position: "start" },
                        react_1.default.createElement(core_1.IconButton, { edge: "end", onClick: handleAddFunction },
                            react_1.default.createElement("i", { className: "ppi ppi-chevron-right" })))),
                };
                break;
            }
            default: {
                if (iconPosition === "left") {
                    iconProp = {
                        startAdornment: iconElement(icon),
                    };
                    break;
                }
                iconProp = {
                    endAdornment: iconElement(icon),
                };
                break;
            }
        }
        iconProp.className = getClassnameByType();
        return iconProp;
    };
    var renderMultilineResizable = function () {
        return (react_1.default.createElement(core_1.TextareaAutosize, { className: getClassnameByType(), value: props.value, name: props.name, rowsMin: props.minRows, rowsMax: props.maxRows, minLength: props.minLength, maxLength: props.maxLength, placeholder: props.placeholder, disabled: disabled, readOnly: readOnly, required: required, onChange: handleChange }));
    };
    var checkMaxMin = function (value) {
        if (props.max !== undefined && (value > parseInt(props.max.toString())))
            return props.max;
        if (props.min !== undefined && (value < parseInt(props.min.toString())))
            return props.min;
        return value;
    };
    var handleChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _event, s;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!onChange) return [3 /*break*/, 2];
                    if (props.type === 'number' && props.step) {
                        _event = event;
                        if (_event.nativeEvent.inputType === undefined) {
                            if (Number(_event.target.value) < Number(props.value)) {
                                _event.target.value = Number(props.value) - Number(props.step);
                            }
                            else if (Number(_event.target.value) > Number(props.value)) {
                                _event.target.value = Number(props.value) + Number(props.step);
                            }
                            _event.target.value = checkMaxMin(parseInt(_event.target.value));
                            onChange(_event);
                        }
                        else {
                            onChange(event);
                        }
                    }
                    else
                        onChange(event);
                    if (!sugestions) return [3 /*break*/, 2];
                    setLoadingSugestionsList(true);
                    return [4 /*yield*/, sugestions(event.target.value)];
                case 1:
                    s = _a.sent();
                    setLoadingSugestionsList(false);
                    setSugestionsList(s);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var renderSugestions = function (name) {
        return (react_1.default.createElement("div", { className: classes.sugestions }, loadingSugestionsList ?
            react_1.default.createElement("span", { className: "loading" },
                " ",
                react_1.default.createElement("i", { className: "ppi ppi-loading ppi-spin" }),
                "\u00A0Carregando sugest\u00F5es...")
            :
                sugestionsList.length > 0 ?
                    sugestionsList.map(function (item, index) {
                        return (react_1.default.createElement("span", { key: index, className: "sugestion ".concat(item.disabled ? 'disabled' : ''), onClick: function () { !item.disabled && handleChange({ target: { name: name, value: item.value } }); }, dangerouslySetInnerHTML: { __html: item.value.replace(props.value, "<b>".concat(props.value, "</b>")) } }));
                    })
                    :
                        (props.value.length > 0 &&
                            react_1.default.createElement("span", { className: 'sugestion disabled' }, "Nenhuma sugest\u00E3o encontrada"))));
    };
    var renderTextField = function () {
        return (react_1.default.createElement(core_1.TextField, __assign({}, props, { autoComplete: sugestions && 'off', onFocus: function () { setFocused(true); }, onBlur: function () { setTimeout(function () { return setFocused(false); }, 200); }, type: props.mask ? "text" : props.type || "text", name: props.name, id: "id_".concat(props.name), value: props.value, onChange: handleChange, size: "small", variant: "outlined", InputProps: icon || upDown
                ? renderIcon()
                : { className: getClassnameByType(), readOnly: readOnly }, inputProps: { min: props.min, max: props.max }, disabled: disabled, label: false, fullWidth: true, rows: props.rows && props.rows })));
    };
    return (react_1.default.createElement(core_1.ThemeProvider, { theme: theme_1.theme },
        react_1.default.createElement(core_1.Box, { className: "colorFont" },
            react_1.default.createElement(core_1.Grid, { container: true },
                react_1.default.createElement(core_1.Grid, { item: true, xs: sizes, sm: sizes, md: sizes, lg: sizes, xl: sizes, className: classes.item },
                    label && (react_1.default.createElement(core_1.Grid, { container: true, className: classes.label },
                        react_1.default.createElement(core_1.Grid, { item: true, xs: true, sm: true, md: true, lg: true, xl: true }, label),
                        react_1.default.createElement(core_1.Grid, { item: true }, help && helpIcon && (react_1.default.createElement(core_1.Tooltip, { className: classes.tooltip, title: help },
                            react_1.default.createElement("i", { className: "ppi ppi-question-mark-circle" })))))),
                    react_1.default.createElement(PPTooltip_1.default, { content: props.error ? help : '', position: "left", trigger: 'hover' }, multiline ? renderMultilineResizable() : renderTextField()),
                    sugestions && focused && props.name && props.value !== '' && !(readOnly || disabled) &&
                        renderSugestions(props.name))))));
};
exports.PPTextField = PPTextField;
